import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToolbarButton } from '../../../models/toolbar-button/toolbar-button';
import { ServiceDefinitionComponent } from './service-definition.component';

const routes: Routes = [
  {
    path: 'definition',
    component: ServiceDefinitionComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE,
    }
  },
  {
    path: 'definition/extend/:blueprintId',
    component: ServiceDefinitionComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceDefinitionRoutingModule {

}
